module.exports = __webpack_public_path__ + "img/logo_top.8a5bf658.png";